export interface FilePathBreadcrumb {
	label: string;
	path: string;
	isCurrent: boolean;
}

/** ファイルの相対パスを、各階層へ遷移できるパンくず項目へ変換する。 */
export function buildFilePathBreadcrumbs(path: string): FilePathBreadcrumb[] {
	const segments = path.split("/").filter(Boolean);
	return segments.map((label, index) => ({
		label,
		path: segments.slice(0, index + 1).join("/"),
		isCurrent: index === segments.length - 1,
	}));
}
